import StarsComponent from './stars.component'

const StarsModule = angular.module('cdbl.form.stars', [

])
  .component('cdblStars', StarsComponent)
  .name

export default StarsModule
